import React, {useState, useEffect} from 'react';
import {Popconfirm, Button, Modal} from 'antd';
import {EditOutlined, EyeOutlined, EyeInvisibleOutlined, DeleteOutlined} from '@ant-design/icons';
import EditModalContent from './EditModalContent';


const IconGroup = ({ele, updateCallback, hideCallback, deleteCallback, countryData, cropData}) => {
	const [editModalOpen, setEditModalOpen] = useState(false);

	const showEditModal = () => {
    	setEditModalOpen(true);
  	};

  	const handleEditCancel = () => {
	    setEditModalOpen(false);
  	};

	const confirmHide = (active) => {
		console.log(`hiding entry ${JSON.stringify(ele)}`)
		const body = {is_active: active}
		hideCallback(ele.id, {is_active: active})
	}

	const deleteEntry = () => {
		console.log(`deleting entry ${ele}`)
		deleteCallback(ele.id)
	}

	return(
		<div className='flex items-center'>
			<EditOutlined className="pr-2 cursor-pointer text-primaryBlue" onClick={() => setEditModalOpen(true)}/>
			<Popconfirm
			    description="Are you sure you want to delete this?"
			    onConfirm={deleteEntry}
			    // onCancel={cancel}
			    okText="Yes"
			    cancelText="No"
			>
		      <DeleteOutlined className="pr-2 cursor-pointer text-dangerRed"/>
		    </Popconfirm>
		    <Popconfirm
			    description={`Are you sure you want to ${ele.is_active ? 'hide' : 'unhide'} this?`}
			    onConfirm={() => confirmHide(!(ele.is_active))}
			    // onCancel={cancel}
			    okText="Yes"
			    cancelText="No"
			>
			{ele.is_active?
				<EyeOutlined className="pr-2 cursor-pointer text-primaryBlue"/>
			:
	      		<EyeInvisibleOutlined className="pr-2 cursor-pointer text-primaryBlue"/>
			}
		    </Popconfirm>
		    <Modal maskClosable={false} title={<div className='mb-5 font-IBMPlexSansBold text-2xl'>Edit Site</div>} open={editModalOpen} onCancel={handleEditCancel} footer={null}>
		        <EditModalContent countryData={countryData} setOpen={setEditModalOpen} data={ele} updateCallback={updateCallback} cropData={cropData}/>
	      	</Modal>
		</div>
	)
}

export default IconGroup;